import { PRIVATE_ROUTES, PUBLIC_EXCEPTIONS } from "./constants";

export const isPrivateRoute = (url: string): boolean => {
    if (PUBLIC_EXCEPTIONS.includes(url)) {
        return false;
    }
    return PRIVATE_ROUTES.includes(url);
};